import React, { lazy } from 'react';
const galleryImages = [{
  src: 'https://cdn.magicpatterns.com/uploads/dWg2no4M1pY64U4pSCqbfJ/623561721_18046915046498843_801347899166348057_n.jpg',
  alt: 'Charcoal paver walkway alongside a Las Vegas home with desert rock landscaping'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/cHXJcVnC2kYN8doJPjpoc4/571932228_17935932768067515_3695252231685561231_n.jpg',
  alt: 'Paver patio at dusk with string lights, fire table, and artificial turf'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/dBC6P2UVy2KZuiDfJB4FYX/572475314_17935932792067515_5811276371888328879_n.jpg',
  alt: 'Illuminated paver side-yard pathway with topiaries and ground lighting at night'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/r8t1ZxKdGTbYWuUFf1mSKz/623801684_18072392780453035_1157169876869010793_n.jpg',
  alt: 'Lush artificial turf lawn bordered by desert rock and a wood planter'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/xADbT2Y323CrZLGzfNf5p2/618907938_17948723142082321_3369223182604105591_n.jpg',
  alt: 'Artificial turf lawn framed by charcoal paver borders next to a covered patio'
}];
export function WorkGallery() {
  // Duplicate the set so the marquee can loop seamlessly
  const loopImages = [...galleryImages, ...galleryImages];
  return <section id="work" className="py-20 md:py-28 bg-charcoal text-white overflow-hidden" data-id="element-232">
      <div className="container mx-auto px-4" data-id="element-233">
        <div className="max-w-2xl mb-12 md:mb-16" data-id="element-234">
          <p className="text-teal font-bold uppercase tracking-widest text-sm mb-4" data-id="element-235">
            Our Work
          </p>
          <h2 className="text-3xl md:text-5xl font-extrabold font-heading tracking-tight mb-4" data-id="element-236">
            Real Projects, Real Craftsmanship
          </h2>
          <p className="text-sand text-lg" data-id="element-237">
            A look at recent paver, turf, and outdoor living installations
            across the Las Vegas valley.
          </p>
        </div>
      </div>

      {/* Full-bleed auto-scrolling marquee */}
      <div className="relative w-full" style={{
      maskImage: 'linear-gradient(to right, transparent, black 6%, black 94%, transparent)',
      WebkitMaskImage: 'linear-gradient(to right, transparent, black 6%, black 94%, transparent)'
    }} data-id="element-238">
        <div className="flex w-max gap-6 px-6 animate-work-marquee hover:[animation-play-state:paused]" data-id="element-239">
          {loopImages.map((image, index) => <div key={index} className="relative flex-shrink-0 w-[280px] sm:w-[340px] md:w-[420px] aspect-[3/4] rounded-2xl overflow-hidden shadow-2xl bg-charcoal-soft" data-id="element-240">
              <img src={image.src} alt={image.alt} loading="lazy" className="w-full h-full object-cover" data-id="element-241" />
            </div>)}
        </div>
      </div>
    </section>;
}